class TopBanner {
  constructor() {
    this.selectors = {
      banner: '[data-top-banner]',
      carousel: '.top-banner__messages',
      message: '.promo-message',
      chevronPrev: '.promo-chevron--prev',
      chevronNext: '.promo-chevron--next',
    };

    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', () => this.init())
      : this.init();
  }

  init() {
    this.initBanner();
  }

  initBanner() {
    const banner = document.querySelector(this.selectors.banner);
    if (!banner) return;
    
    this.initCarousel(banner);
    this.bindBannerClicks(banner);
  }

  initCarousel(container) {
    const slider = container.querySelector(this.selectors.carousel);
    if (!slider) return;

    const slides = [...slider.querySelectorAll(this.selectors.message)]
      .filter(s => !s.classList.contains('promo-message--hidden'));

    const loop = slides.length > 1;

    // Toggle navigation visibility
    ['Prev', 'Next'].forEach(dir => {
      const btn = container.querySelector(this.selectors[`chevron${dir}`]);
      if (btn) btn.style.display = loop ? 'flex' : 'none';
    });

    if (loop) {
      new Swiper(slider, {
        loop,
        direction: 'vertical',
        speed: 700,
        slidesPerView: 1,
        autoplay: { delay: 5000, pauseOnMouseEnter: true },
        navigation: {
          prevEl: container.querySelector(this.selectors.chevronPrev),
          nextEl: container.querySelector(this.selectors.chevronNext),
        },
        allowTouchMove: false,
      });
    }
  }

  bindBannerClicks(banner) {
    banner.addEventListener('click', e => {
      const target = e.target;

      if (target.closest('.promo-chevron')) return;
      if (target.closest('.promo-link, a')) return;

      if (target.closest('.promo-text[data-message="discount"]')) {
        e.preventDefault();
        this.openRegistrationPopup();
        return;
      }
    });
  }

  openRegistrationPopup() {
    if (window.openRegistrationPopup) return window.openRegistrationPopup();

    const popup = document.getElementById('registration-discount-popup');
    if (!popup) return;

    const scrollY = window.scrollY;
    popup.style.display = 'flex';
    document.body.classList.add('popup-open');
    document.body.style.cssText = `
      position: fixed;
      top: -${scrollY}px;
      width: 100%;
      overflow: hidden;
    `;

    requestAnimationFrame(() => popup.classList.add('show'));
  }
}

// Init + Shopify Support
if (!window.topBannerInstance) window.topBannerInstance = new TopBanner();
document.addEventListener('shopify:section:load', () => window.topBannerInstance.initBanner());
